"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import { getStencilPathData } from "./stencil-paths.js";
import classNames from "classnames";
export { stencilKeys } from "./constants.js";
export function StencilShape({ variant, type = "raw", children, className = "", style, }) {
    const clipPathId = useId();
    const pathData = getStencilPathData(variant);
    if (!pathData) {
        return null; // Fallback: unsupported variant
    }
    const { pathData: path, viewBox } = pathData;
    const shapeId = `url(#${clipPathId})`;
    // Raw SVG variant: bare SVG with clipPath, no automatic masking
    if (type === "raw") {
        return (_jsx("svg", { className: classNames(className), style: style, viewBox: viewBox, xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", children: _jsx("path", { d: path }) }));
    }
    return (_jsxs("div", { className: classNames("[&>*:not(svg)]:[clip-path:var(--cvr-stencil-id)]", className), style: { ...(style ?? {}), "--cvr-stencil-id": shapeId }, children: [_jsx("svg", { className: "absolute h-0 w-0", viewBox: viewBox, xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid meet", "aria-hidden": "true", children: _jsx("defs", { children: _jsx("clipPath", { id: clipPathId, clipPathUnits: "objectBoundingBox", children: _jsx("path", { d: path }) }) }) }), children] }));
}
